// extracted by css-extract-rspack-plugin
export default {"cls1":"LanguageDropdown-cls1_hQE","cls2":"LanguageDropdown-cls2_XeB LanguageDropdown-cls1_hQE"};